import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import {
    ButtonGroup,
    CardBody,
    CardTitle,
    CardSubtitle,
    CardFooter,
} from 'reactstrap';
import cls from 'classnames';
import { Weekdays } from '../Common';
import LongTermStatusIndicator from './LongTermStatusIndicator';

export default class EquipmentCard extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            clientHeight: 0,
        };
    }

    componentDidMount() {
        const div = document.getElementById(`equipmentCard-${this.props.equipment.id}`);
        
        this.setState({ clientHeight: (div?.getBoundingClientRect().height ?? 0) });
    }

    setRef = (ref) => {
    // keep a reference to the dom ref as an instance property
        this.ref = ref;
        // give the dom ref to @hello-pangea/dnd
        this.props.innerRef(ref);
    };

    render() {
        const {
            equipment, provided, allJobs, weekdays,
            hiddenEquipmentIds, dragging, longTermStatuses, equipmentLongTermStatuses,
        } = {
            ...this.props,
        };

        if (hiddenEquipmentIds.includes(equipment.id)) {
            return (
                <div
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    ref={this.setRef}
                />
            );
        }

        const Component = dragging ? 'div' : 'dd';
        const PlaceholderComponent = dragging ? 'dd' : 'div';

        return (
            <>
                <Component
                    id={`equipmentCard-${equipment.id}`}
                    className={cls('card equipmentCard', {
                        compact: !!this.props.compact,
                        minimal: !!this.props.minimal,
                        dragging,
                    })}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    ref={this.setRef}
                >
                    <div className="dragIndicator">
                        <FontAwesomeIcon icon={faEllipsisV} />
                        <FontAwesomeIcon icon={faEllipsisV} />
                    </div>
                    <CardBody>
                        <CardTitle className="card-title">
                            <span className="staff-info">
                                {equipment.description}
                            </span>

                            <div className="status-icons">
                                <LongTermStatusIndicator
                                    staff={equipment}
                                    longTermStatuses={longTermStatuses}
                                    employeeLongTermStatuses={
                                        equipmentLongTermStatuses
                                    }
                                />
                            </div>
                        </CardTitle>

                        <CardSubtitle>
                            <label>{equipment.equipmentType.description}</label>
                        </CardSubtitle>

                        <CardFooter>
                            <ButtonGroup className="" size="sm">
                                {weekdays.map((dayDate) => {
                                    const day = Weekdays.find(
                                        (x) => x.id === dayDate.getDay(),
                                    );
                                    return (
                                        <span
                                            key={day.id}
                                            className={cls(
                                                'btn btn-sm btn-outline-secondary scheduledDayIndicator',
                                                {
                                                    active: !!allJobs.find(
                                                        (j) => !!j.assignments[
                                                            day.id
                                                        ].equipment.find(
                                                            (e) => !!e.assignment
                                                                && e.assignment
                                                                    .id
                                                                    === equipment.id,
                                                        ),
                                                    ),
                                                },
                                            )}
                                        >
                                            {day.abbreviationShort}
                                        </span>
                                    );
                                })}
                            </ButtonGroup>
                        </CardFooter>
                    </CardBody>
                </Component>

                <PlaceholderComponent
                    className="card equipmentCard placeholder"
                    style={{ height: this.state.clientHeight }}
                />
            </>
        );
    }
}
